import { WizardFooter, WizardFooterProps } from '../WizardFooter/WizardFooter';

import { screenFooter } from './WizardScreen.css';

export const WizardScreenFooter = (props: WizardFooterProps) => {
    return <WizardFooter {...props} className={screenFooter} />;
};

WizardScreenFooter.displayName = 'WizardScreen.Footer';
